import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import CheckboxBase, { CheckboxBaseProps } from "@/components/ui/Form/Filters/components/Checkbox/CheckboxBase";

export interface CheckboxControlledProps extends CheckboxBaseProps {
  control: Control;
}
const CheckboxControlled: FC<CheckboxControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <CheckboxBase field={field} fieldState={fieldState} {...rest} />;
};
export default CheckboxControlled;
